<template>
  <div
    class="modal travel-order fade"
    id="travelOrderModal"
    tabindex="-1"
    ref="travelOrder"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content travel-order__content">
        <button
          type="button"
          class="travel-order__close btn--reset"
          data-dismiss="modal"
          :aria-label="i18n.closeModal"
          @click="() => setModalIsOpen(false)"
        >
          <Icon name="times" extra-classes="icon--sm" />
          <span class="sr-only">{{ i18n.closeModal }}</span>
        </button>

        <div class="modal-body travel-order__body">
          <div class="h2 color-text-dark font-weight-bold mb-4 mb-md-5">
            {{ i18n.changeYourTravelOrder }}
          </div>

          <div v-if="cart.dateOfArrival" class="d-flex align-items-center">
            <div class="mr-3">
              {{ i18n.changeDateOfArrival }}
            </div>

            <DatePicker
              property="dateOfArrival"
              :date="cart.dateOfArrival"
            />
          </div>

          <div class="travel-order__items">
            <TravelOrderItem
              v-for="(cartItem, index) in cartItemsConcept"
              :key="cartItem.id"
              :index="index + 1"
              :cart-item="cartItem"
              :is-first="index === 0"
              :is-last="index === (cartItemsConcept.length - 1)"
              @move="handleMove"
            />
          </div>

          <div class="d-flex justify-content-center mt-4 mt-md-5">
            <button
              class="travel-order__save btn btn--primary btn--lg w-100"
              type="button"
              @click="() => onRecalculateClick()"
            >
              {{ i18n.recalculateMyJourney }}
            </button>
          </div>
        </div>

        <TravelOrderAlert />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import { arrayMoveImmutable } from 'array-move';
import Icon from '@/cart/components/Icon.vue';
import DatePicker from '@/cart/components/DatePicker.vue';
import TravelOrderItem from '@/cart/components/TravelOrderItem.vue';
import TravelOrderAlert from '@/cart/components/TravelOrderAlert.vue';

export default {
  components: {
    Icon,
    DatePicker,
    TravelOrderItem,
    TravelOrderAlert,
  },

  computed: {
    ...mapGetters([
      'cart',
      'cartItemsConcept',
      'modalIsOpen',
    ]),
  },

  watch: {
    modalIsOpen(value) {
      this.toggleModal(value);
    },
  },

  mounted() {
    $(this.$refs.travelOrder).on('hide.bs.modal', () => this.setModalIsOpen(false));
  },

  destroyed() {
    $(this.$refs.travelOrder).off('hide.bs.modal', () => this.setModalIsOpen(false));
  },

  methods: {
    ...mapActions([
      'recalculateCartItems',
    ]),

    ...mapMutations([
      'setCartItemsConcept',
      'setModalIsOpen',
    ]),

    toggleModal(state) {
      $(this.$refs.travelOrder).modal(state ? 'show' : 'hide');
    },

    handleMove(id, direction) {
      const currentIndex = this.getBlockIndexById(id);
      const cartItemsArray = Array.prototype.slice.call(this.cartItemsConcept);

      this.cartItemsArray = [];

      this.$nextTick(() => {
        if (currentIndex !== null && cartItemsArray.length >= 1) {
          const newIndex = direction === 'up'
            ? currentIndex - 1
            : currentIndex + 1;

          this.cartItemsArray = arrayMoveImmutable(cartItemsArray, currentIndex, newIndex);

          this.setCartItemsConcept(this.cartItemsArray);
        }
      });
    },

    getBlockIndexById(id) {
      let index = null;

      this.cartItemsConcept.forEach((cartItem, cartItemIndex) => {
        if (cartItem.id === id) {
          index = cartItemIndex;
        }
      });

      return index;
    },

    onRecalculateClick() {
      this.recalculateCartItems();
    },
  },
};
</script>
